import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="none"
      viewBox="0 0 10 10"
    >
      <path
        fill="#202020"
        d="M5 4.057l3.3-3.3.943.943-3.3 3.3 3.3 3.3-.943.943-3.3-3.3-3.3 3.3L.757 8.3l3.3-3.3-3.3-3.3L1.7.757l3.3 3.3z"
      ></path>
    </svg>
  )
}

export default Icon
